import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kehudengji",
  "use": "icon-kehudengji-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-kehudengji\"><path d=\"M14.077 2.708C10.7 2.708 8.381.741 8.351.718a.483.483 0 00-.686.061C6.466 2.281 3.395 2.678 1.93 2.678c-.114.015-.251.045-.343.137a.485.485 0 00-.145.343v5.513c0 2.379 3.63 6.65 6.596 6.65 3.111 0 6.52-4.385 6.52-6.475V3.19c0-.26-.214-.48-.48-.48zm-.48 6.138c0 1.663-3.088 5.513-5.559 5.513-2.364 0-5.635-3.782-5.635-5.68V3.63c1.182-.054 4.11-.35 5.696-1.899.793.572 2.783 1.792 5.498 1.922v5.192zM5.834 5.438a.482.482 0 00-.869.42l2.6 4.94a.482.482 0 00.427.275c.183 0 .351-.1.427-.267l2.684-4.941a.479.479 0 00-.213-.64.479.479 0 00-.64.213L8 9.502 5.834 5.438z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kehudengji.svg
// module id = 483
// module chunks = 4